import { DownloadButtonAnimation } from '@repo/animations/src/download-button-animation'
import { tw } from 'utils/classnames'

export function ActivateTrialLabel({
  children,
  className,
  withAnimation = true,
}: {
  children: React.ReactNode
  className?: string
  withAnimation?: boolean
}) {
  return (
    <span className={tw('flex items-center justify-center gap-2', className)}>
      {withAnimation ? <DownloadButtonAnimation className="h-[28px] w-[28px]" /> : null}
      {children}
    </span>
  )
}
